<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div
          :class="{
            'has-error':
              validations.guia.procedimentosRealizados.procedimentos.$error,
          }"
          class="form-group"
        >
          <span v-if="validations.guia.procedimentosRealizados.$dirty">
            <span
              v-if="
                !validations.guia.procedimentosRealizados.procedimentos
                  .maxLength
              "
              class="help-block"
            >
              Até
              {{
                validations.guia.procedimentosRealizados.procedimentos.$params
                  .maxLength.max
              }}
              procedimentos são permitidos.
            </span>
            <span
              v-else-if="
                !validations.guia.procedimentosRealizados.procedimentos.required
              "
              class="help-block"
            >
              Deve ser adicionado um procedimento.
            </span>
            <span
              v-else-if="
                validations.guia.procedimentosRealizados.procedimentos.$error
              "
              class="help-block"
            >
              Existem erros no(s) procedimento(s) informado(s), deve ser
              informado pelo menos um procedimento.
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div
          v-for="(procedimento, index) in guia.procedimentosRealizados
            .procedimentos"
          :key="procedimento._id"
        >
          <ProcedimentoRealizado
            :guia="guia"
            :index="index"
            :validations="validations"
            :procedimento="procedimento"
            :visao-simplificada="visaoSimplificada"
            @recalcular="recalcularGuia"
          />
          <hr />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="form-group">
          <div class="form-group">
            <label>64 - Observação</label>
            <textarea
              v-model="guia.procedimentosRealizados.observacao"
              data-test-id="textarea-guia-procedimentosrealizados-observacao"
              :readonly="!verificaAcao('faturamento_guia')"
              class="form-control"
              rows="3"
              placeholder="Observações pertinentes ao procedimento realizado."
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="verificaAcao('faturamento_guia')" class="row">
      <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
        <div class="form-group form-group-sm">
          <label for="fatorMultiplicador">Fator multiplicador</label>
          <input
            id="fatorMultiplicador"
            v-model="guia.procedimentosRealizados.fatorMultiplicador"
            v-mask="'9'"
            v-tooltip="
              'Use para multiplicar o valor total pelo número informado.'
            "
            data-test-id="input-fatormultiplicador"
            :disabled="guia.procedimentosRealizados.fixarValor"
            name="fatorMultiplicador"
            type="number"
            class="form-control input-sm"
            @change="recalcularGuia"
          />
        </div>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-2 col-lg-2">
        <div
          v-tooltip="
            'Use para fixar um valor no total da guia e desconsiderar os procedimentos realizados e o fator multiplicador.'
          "
          class="checkbox"
          style="margin-top: 27px"
        >
          <label>
            <input
              id="fixarValor"
              v-model="guia.procedimentosRealizados.fixarValor"
              data-test-id="input-fixarvalor"
              type="checkbox"
              name="ficarValor"
              @change="recalcularGuia"
            />
            Fixar valores
          </label>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>65 - Total procedimentos</label>
          <input
            v-if="!verificaAcao('faturamento_guia')"
            v-mask="'money'"
            data-test-id="input-auto-4"
            type="text"
            class="form-control"
            placeholder="Valor em R$ dos procedimentos"
            readonly
          />
          <input
            v-else
            v-model="guia.procedimentosRealizados.totalProcedimentos"
            v-mask="'money'"
            data-test-id="input-guia-procedimentosrealizados-totalprocedimentos"
            type="text"
            class="form-control"
            placeholder="Valor em R$ dos procedimentos"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>66 - Total taxas e aluguéis</label>
          <input
            v-if="!verificaAcao('faturamento_guia')"
            v-mask="'money'"
            data-test-id="input-auto-6"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de taxas e aluguéis"
            readonly
          />
          <input
            v-else
            v-model="guia.procedimentosRealizados.totalTaxasAlugueis"
            v-mask="'money'"
            data-test-id="input-guia-procedimentosrealizados-totaltaxasalugueis"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de taxas e aluguéis"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>67 - Total materiais</label>
          <input
            v-if="!verificaAcao('faturamento_guia')"
            v-mask="'money'"
            data-test-id="input-auto-8"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de materiais"
            readonly
          />
          <input
            v-else
            v-model="guia.procedimentosRealizados.totalMateriais"
            v-mask="'money'"
            data-test-id="input-guia-procedimentosrealizados-totalmateriais"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de materiais"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>68 - Total medicamentos</label>
          <input
            v-if="!verificaAcao('faturamento_guia')"
            v-mask="'money'"
            data-test-id="input-auto-10"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de medicamentos"
            readonly
          />
          <input
            v-else
            v-model="guia.procedimentosRealizados.totalMedicamentos"
            v-mask="'money'"
            data-test-id="input-guia-procedimentosrealizados-totalmedicamentos"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de medicamentos"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>69 - Total diárias</label>
          <input
            v-if="!verificaAcao('faturamento_guia')"
            v-mask="'money'"
            data-test-id="input-auto-12"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de diárias"
            readonly
          />
          <input
            v-else
            v-model="guia.procedimentosRealizados.totalDiarias"
            v-mask="'money'"
            data-test-id="input-guia-procedimentosrealizados-totaldiarias"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de diárias"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>70 - Total gases medicinais</label>
          <input
            v-if="!verificaAcao('faturamento_guia')"
            v-mask="'money'"
            data-test-id="input-auto-14"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de gases medicinais"
            readonly
          />
          <input
            v-else
            v-model="guia.procedimentosRealizados.totalGases"
            v-mask="'money'"
            data-test-id="input-guia-procedimentosrealizados-totalgases"
            type="text"
            class="form-control"
            placeholder="Valor em R$ de gases medicinais"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>71 - Total geral da guia</label>
          <input
            data-test-id="input-auto-16"
            type="text"
            class="form-control"
            placeholder="Valor em R$ do total geral da guia"
            readonly
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'

import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import appStore from '@/stores'

import ProcedimentoRealizado from './ProcediemntoRealizado'

const controleAcessoServico = new ControleAcessoServico()

export default {
  name: 'ProcedimentosRealizados',
  components: { ProcedimentoRealizado },
  directives: { mask: AwesomeMask },
  props: {
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {}
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
  },
  methods: {
    recalcularGuia(dados) {
      this.$emit('recalcular')
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
  },
}
</script>
